import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../../../config/app-config.service';
import { GenerateToken, InsertUserProfileCommand, ServiceResult, tblUserProfile, UpdateUserProfileCommand, UserProfileDetails, UserRole } from '../../../_models/app-models';

@Injectable({
  providedIn: 'root'
})

export class UserProfileService {
  Base_URL: string;
  httpOptions: { headers: HttpHeaders };
  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.Base_URL = this.appConfigService.getConfigByKey("portal");
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-ApiKey': this.appConfigService.getConfigByKey("portalApiKey")
      })
    };
  }

  // Get Profile based on Username and local accountId form b2c details.
  GetProfileUserByUserName(username, localAccountId): Observable<tblUserProfile> {
    return this.http
      .get<ServiceResult<tblUserProfile>>(this.Base_URL + '/UserProfile/GetProfileUserByUserName?username=' + username + '&accountId=' + localAccountId, this.httpOptions)
      .pipe(map(r => this.extractData(r)));
  }

  GetUserProfile(coreUserId): Observable<tblUserProfile> {
    return this.http
      .get<ServiceResult<tblUserProfile>>(this.Base_URL + '/UserProfile?coreUserId=' + coreUserId, this.httpOptions)
      .pipe(map(r => r.data));
  }

  CheckAdminRole(coreUserId): Observable<UserRole> {
    return this.http
      .get<ServiceResult<UserRole>>(this.Base_URL + '/UserProfile/CheckAdminRole?coreUserId=' + coreUserId, this.httpOptions)
      .pipe(map(r => r.data));
  }

  CreateUserProfile(userProfileDetails: UserProfileDetails): Observable<tblUserProfile> {
    let insertUserProfileCommand: InsertUserProfileCommand = {
      userProfile: userProfileDetails.userProfile
    };
    return this.http
      .post<ServiceResult<tblUserProfile[]>>(this.Base_URL + '/UserProfile/UserProfileDetails', insertUserProfileCommand, this.httpOptions)
      .pipe(map(r => this.extractData(r)));
  }

  UpdateUserProfile(userProfileDetails: UserProfileDetails): Observable<tblUserProfile> {
    let updateUserProfileCommand: UpdateUserProfileCommand = {
      userProfile: userProfileDetails.userProfile
    };
    return this.http
      .put<ServiceResult<tblUserProfile[]>>(this.Base_URL + '/UserProfile/UserProfileDetails', updateUserProfileCommand, this.httpOptions)
      .pipe(map(r => this.extractData(r)));
  }

  GetApiToken(username, localAccountId): Observable<any> {
    let generateTokenServiceCommand: GenerateToken = {
      tokenDetails: {
        userName: username,
        accountId: localAccountId
      }
    };

    return this.http
      .post<ServiceResult<any>>(this.Base_URL + '/TokenService/GenerateToken', generateTokenServiceCommand, this.httpOptions)
      .pipe(map(r => this.extractData(r)));
  }

  completeResponse(res: any) {
    return res;
  }

  extractData(res: any) {
    return res.data;
  }
}
